import { supabase } from '../../supabaseClient';

const ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;
const fnUrl = (name) => `${process.env.REACT_APP_SUPABASE_URL}/functions/v1/${name}`;

async function post(name, headers, body) {
  try {
    const res = await fetch(fnUrl(name), {
      method: 'POST',
      headers: { apikey: ANON_KEY, 'Content-Type': 'application/json', ...headers },
      body: JSON.stringify(body),
    });
    let b = null;
    try { b = await res.json(); } catch { b = null; }
    if (!res.ok) {
      return { error: { message: b?.error || 'Erro na operação', status: res.status } };
    }
    return { data: b?.data ?? b };
  } catch (e) {
    return { error: { message: e?.message || 'Falha de rede' } };
  }
}

// Páginas públicas /external-* — sem Bearer (o token do link é a credencial).
export const fetchExternalView = (kind, token) =>
  post('external-access', {}, { op: 'view', kind, token });

export const sendExternalAction = (kind, token, action, signature) =>
  post('external-access', {}, { op: 'action', kind, token, action, signature });

// Geração de link — autenticada; usa o JWT da sessão do usuário logado.
export const issueExternalLink = (kind, id) => {
  const authToken = supabase.auth.session()?.access_token;
  if (!authToken) {
    return Promise.resolve({ error: { message: 'Sessão expirada. Faça login novamente.' } });
  }
  return post('issue-external-link', { Authorization: `Bearer ${authToken}` }, { kind, id });
};
